
import {makeStyles} from '@material-ui/core/styles'
import {colors} from '../../shared/colors'

const useStyles = makeStyles( theme => ({

    root:{
        margin: theme.spacing(3)
    },
    body:{
        padding: theme.spacing(2)
    },
    dropzone: ({isDragActive, isFileDialogActive}) => ({
        width : '100%',
        height : '100%',
        border : (isDragActive || isFileDialogActive) ? `0.3rem dashed ${colors.dhcsBlue}` : '0.3rem dashed gray'
    }),
    dZoneInput:{
        display: 'flex',
        flexDirection: 'row',
        padding: theme.spacing(1),
    },
    uploadIcon: {
        color: colors.dhcsBlue,
        transform: 'scale(1.5)',
        padding: '0.3rem'
    },
    uploadMessage: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: '1.2rem',
        width: '100%'
    },
    maxSizeMessage: {
        display: 'flex',
        justifyContent: 'center',
        color: colors.magellanDarkBlue,
        padding: theme.spacing(1)
    },
    fileTypesMessage: {
        display: 'flex',
        justifyContent: 'center',
        color: colors.magellanBlack,
        padding: theme.spacing(1),
        fontWeight: '700'
    },
    header1: {
        fontSize: '1.3rem',
        fontWeight: '400',
        color: colors.magellanBlack,
        width: '100%',
        marginBottom: '0.5rem',
        textAlign: 'center'
    },
    header4: {
        fontSize: '1.3rem',
        fontWeight: '400',
        color: colors.magellanBlack,
        width: '100%',
        textAlign: 'center',
        paddingBottom: '1.5rem'
    }
}));

export default useStyles
